import { render, staticRenderFns } from "./ListResponsavelWebhookView.vue?vue&type=template&id=21f9edfc&"
import script from "./ListResponsavelWebhookView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelWebhookView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports